import { validate as isUuid } from 'uuid';
import { sanitizeFilterQueryValue } from './sanitizeFilterQueryValue';

/**
 * Builds a q filter DSL condition matching identity team members by user id.
 * The q param is mutually exclusive with the legacy userIds= param, which
 * matched non-UUID values against legacyExternalId — mixed id lists keep that
 * tolerance via an OR across both columns. Legacy ids are sanitized since
 * they are caller-supplied strings rather than validated UUIDs.
 */
export function buildUserIdsCondition(userIds: string[]): string {
  const identityIds = userIds.filter((id) => isUuid(id));
  const legacyIds = userIds
    .filter((id) => !isUuid(id))
    .map(sanitizeFilterQueryValue)
    .filter(Boolean);
  const conditions = [
    identityIds.length ? `user.id[in]=[${identityIds.join(',')}]` : null,
    legacyIds.length ? `legacyExternalId[in]=[${legacyIds.join(',')}]` : null,
  ].filter((condition): condition is string => Boolean(condition));
  // Always grouped, even for a single clause, so callers can append further
  // `&` clauses without caring how many id columns matched.
  return conditions.length ? `(${conditions.join(' | ')})` : '';
}
